import React from 'react';
import { CtaButton } from './CtaButton';
import { CHECKOUT_MEGAPACK, CHECKOUT_MEGAPACK_KIT } from '../data/content';
type Plan = {
  emoji: string;
  name: string;
  includes: string;
  idealFor?: string;
  oldPrice: string;
  price: string;
  cta: string;
  href: string;
  featured: boolean;
};
const plans: Plan[] = [{
  emoji: '📘',
  name: 'MegaPack Caligrafía y Lectoescritura',
  includes: '6 Tomos + 6 Bonos',
  idealFor: 'Familias y docentes · Tomo 1 → Tomo 6',
  oldPrice: '$51.000',
  price: '$19.990 ARS',
  cta: '→ Quiero mi MegaPack',
  href: CHECKOUT_MEGAPACK,
  featured: false
}, {
  emoji: '🏆',
  name: 'MegaPack + Kit Necesidades Especiales',
  includes: '6 Tomos + 6 Bonos + Kit Inclusión completo',
  idealFor: 'Grupos heterogéneos, NEE, niveles mixtos, aprendizaje con barreras',
  oldPrice: '$69.000',
  price: '$27.990 ARS',
  cta: '→ Quiero el MegaPack + Kit Inclusión',
  href: CHECKOUT_MEGAPACK_KIT,
  featured: true
}];
type PricingProps = {
  id?: string;
  title?: string;
  compact?: boolean;
};
export function Pricing({
  id = 'precios',
  title = 'Elegí tu MegaPack',
  compact = false
}: PricingProps) {
  return <section id={id} aria-labelledby={`${id}-titulo`} className={`w-full bg-white ${compact ? 'py-10' : 'py-14 sm:py-20'}`} data-id="element-212" data-mp="9si7fusw8azk">
      <div className="mx-auto max-w-5xl px-5" data-id="element-213" data-mp="eqtha5j6ulhs">
        <h2 id={`${id}-titulo`} className="text-center font-display text-3xl font-extrabold uppercase tracking-wide text-navy sm:text-4xl" data-id="element-214" data-mp="3d97gpojv1ysx">
          {title}
        </h2>

        <div className="mt-9 grid gap-6 md:grid-cols-2" data-id="element-215" data-mp="3n7ew42yi48st">
          {plans.map(plan => <article key={plan.name} className={`relative flex flex-col rounded-3xl border-2 p-6 sm:p-7 ${plan.featured ? 'border-gold bg-navy text-white shadow-pop' : 'border-navy/10 bg-cream text-navy shadow-card'}`} data-id="element-216" data-mp="3rxv95lyetsen">
              {plan.featured && <span className="absolute -top-3 left-1/2 -translate-x-1/2 whitespace-nowrap rounded-full bg-gold px-4 py-1 font-display text-xs font-extrabold uppercase tracking-widest text-navy-deep" data-id="element-217" data-mp="2rf1tlzuzle69">
                  ⭐ Más elegido
                </span>}

              <h3 className="mt-2 font-display text-xl font-extrabold leading-tight sm:text-2xl" data-id="element-218" data-mp="2w8mkl7y5x7vy">
                <span aria-hidden="true" data-id="element-219" data-mp="28j20glq9w4l3">{plan.emoji} </span>
                {plan.name}
              </h3>
              <p className={`mt-2 text-sm font-bold ${plan.featured ? 'text-gold' : 'text-celeste-dark'}`} data-id="element-220" data-mp="23k7ejax0dzwr">
                {plan.includes}
              </p>
              {plan.idealFor && <p className={`mt-3 text-sm leading-relaxed ${plan.featured ? 'text-white/75' : 'text-navy/70'}`} data-id="element-221" data-mp="2dj6f067mep8o">
                  <strong className="font-bold" data-id="element-222" data-mp="3ox1szbmsgryb">Ideal para:</strong> {plan.idealFor}
                </p>}

              <div className="mt-6" data-id="element-223" data-mp="9m1gdyu7m93">
                <p className={`text-base font-bold line-through ${plan.featured ? 'text-white/50' : 'text-navy/40'}`} data-id="element-224" data-mp="cqc9u6t5g8q">
                  {plan.oldPrice}
                </p>
                <p className="font-display text-4xl font-extrabold leading-none sm:text-5xl" data-id="element-225" data-mp="3rgorv36upoi9">
                  {plan.price}
                </p>
              </div>

              <CtaButton href={plan.href} variant={plan.featured ? 'primary' : 'secondary'} className="mt-6 w-full text-center" data-id="element-226" data-mp="j1eq5w6vilb0">
                {plan.cta}
              </CtaButton>
            </article>)}
        </div>
      </div>
    </section>;
}